<template>
  <div class="form-act-block">
    <template v-if="actLpoIsDraft">
      <p-split-button
        :model="menuItems"
        disabled
        label="Акт ЛПО"
        class="p-splitbutton-sm form-act-block__btn"
        v-tooltip="'Переведите в чистовик, чтобы сформировать акт ЛПО'"
      />
    </template>
    <template v-else>
      <p-split-button
        :model="menuItems"
        :disabled="isForming || actLpoIsDraft"
        @click="formActPrecheck"
        label="Акт ЛПО"
        class="p-splitbutton-sm form-act-block__btn"
      />
    </template>
    <!-- <p-split-button
      :model="menuItems"
      :disabled="isForming || actLpoIsDraft"
      @click="formActPrecheck"
      label="Акт ЛПО"
      class="p-splitbutton-sm form-act-block__btn"
      v-tooltip='(isForming || actLpoIsDraft) ? "Переведите в чистовик, чтобы сформировать акт ЛПО" : ""'
    /> -->
    <!-- <p-button :disabled='isForming' @click='formAct' label='Сформировать акт' class='p-button-sm form-act-block__btn'/> -->
    <p-spinner v-if="isForming" />

    <p-dialog modal :visible.sync="confirmIsOpen" dismissableMask>
      <template #header>
        <div class="confirm__title">Предупреждение</div>
      </template>
      <div class="confirm__content">
        <div class="confirm__icon">
          <fa-icon size="2x" icon="exclamation-triangle" />
        </div>
        <div class="confirm__info">
          <div class="confirm__proposition">
            Акт формируется позднее, чем спустя 30 дней от даты ЛПО
          </div>
          <div
            v-for="lpo in incorrectDateLpoList"
            :key="lpo.lpo_id"
            class="confirm__section-item"
          >
            {{
              "Выдел " +
                lpo.section +
                "(" +
                lpo.section_lp +
                ") - дата обследования " +
                normalizeDate(lpo.inspection_date)
            }}
          </div>
        </div>
      </div>
      <template #footer>
        <p-button
          label="Отменить"
          @click="confirmIsOpen = false"
          icon="fa fa-times"
          class="p-button-sm p-button-secondary"
        />
        <p-button
          label="Продолжить формирование"
          @click="() => formAct(needExtra)"
          icon="fa fa-check"
          class="p-button-sm p-button-success"
        />
      </template>
    </p-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import fetchData from "@/lib/fetchData";

const ROOT_API = process.env.VUE_APP_ROOT_API;
const FORM_ACT = ROOT_API + "form_act/index.php";

const GET_TAX = ROOT_API + "get_site_data/get_tax.php";
const GET_ACT_LPO_LIST = ROOT_API + "act_data/get_act_lpo_list.php";
const GET_MAIN_DAMAGE_REASONS =
  ROOT_API + "get_site_data/get_main_damage_reasons.php";
const GET_FREQ_PEST = ROOT_API + "get_site_data/get_freq_pest.php";
const GET_FREQ_DISEASE = ROOT_API + "get_site_data/get_freq_disease.php";
const CHECK_S_PLOT = ROOT_API + "get_site_data/check_s_plot.php";
const GET_MODEL_TREES = ROOT_API + "get_site_data/get_model_trees.php";
const GET_VB_PCT = ROOT_API + "get_site_data/get_vb_pct.php";
const CHECK_PROF_MZL_FITS_SKS = ROOT_API + "get_site_data/check_prof_mzl_fits_sks.php";
const CHECK_STOCK = ROOT_API + "get_site_data/check_stock.php";
const CHECK_KPP_TREE_AMOUNT =
  ROOT_API + "get_site_data/check_kpp_tree_amount.php";
const GET_MZL = ROOT_API + 'get_site_data/mzl/get_mzl.php';
const GET_MANUAL_MZL = ROOT_API + 'get_site_data/mzl/get_manual_mzl.php';
export default {
  name: "LpoDataSidebarFormAct",

  data() {
    return {
      isForming: false,

      incorrectDateLpoList: [],
      confirmIsOpen: false,
      needExtra: true,

      menuItems: [
        {
          label: "Сформировать акт без присоединенных файлов",
          command: () => this.formActPrecheck(false),
        },
      ],
    };
  },

  computed: {
    actLpoIsDraft() {
      return this.$store.getters["lpoData/actLpoIsDraft"];
    },

    ...mapState("selectedLpo", {
      selectedLpo: (state) => state.lpo,
      selectedTax: (state) => state.taxData,
      mainDamageList: (state) => state.mainDamageList,
      freqDiseaseList: (state) => state.freqDiseaseList,
      freqPestList: (state) => state.freqPestList,
    }),

    ...mapState("lpoData", {
      currentLpo: (state) => state.currentLpo,
      lpoList: (state) => state.actLpoList,
    }),
    ...mapState('selectedLpo', {
      mzl: state => state.mzl.mzl,
      manualMzl: state => state.mzl.manualMzl,
    }),
    modelTreesAreOpen() {
      return this.$store.getters["selectedLpo/recount/modelTreesAreOpen"];
    },
  },

  methods: {
    normalizeDate(date) {
      return date
        .split("-")
        .reverse()
        .join(".");
    },

    async getTax(lpoList) {
      const taxList = [];

      for (const lpo of lpoList) {
        const form = new FormData();
        form.append("tax_id", lpo.tax_id);

        const tax = await fetchData(GET_TAX, form).then((res) => {
          return res;
        });
        taxList.push(tax);
      }

      return taxList;
    },

    getLpoList() {
      const form = new FormData();
      form.append("lease_id", this.currentLpo.lease_id);

      return fetchData(GET_ACT_LPO_LIST, form).then((res) => {
        return res;
      });
    },

    // getMainDamageList(lpo) {
    // 	const form = new FormData();
    // 	form.append('lpo_id', lpo.lpo_id);

    // 	return fetchData(GET_MAIN_DAMAGE_REASONS, form).then(res => {
    // 		return res;
    // 	});
    // },

    getFreqPest(lpo) {
      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);

      return fetchData(GET_FREQ_PEST, form).then((res) => {
        return res.filter((item) => {
          return item.z_degree != "-";
        });
      });
    },
    getFreqDisease(lpo) {
      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);

      return fetchData(GET_FREQ_DISEASE, form).then((res) => {
        return res.filter((item) => item.dmg_degree != "-");
      });
    },

    checkSPlot(lpo) {
      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);

      return fetchData(CHECK_S_PLOT, form).then((res) => {
        return res?.[0].s_plot_enough;
      });
    },

    getModelTrees(lpo) {
      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);

      return fetchData(GET_MODEL_TREES, form).then((res) => {
        return res;
      });
    },

    getVbPct(lpo) {
      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);

      return fetchData(GET_VB_PCT, form).then((res) => {
        return res.czl_get_vb_pct;
      });
    },

    checkProfMzlFitsSks(lpo) {
      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);

      return fetchData(CHECK_PROF_MZL_FITS_SKS, form)
        .then((res) => {
          return res?.[0].czl_check_prof_mzl_fits_sks;
        })
        .catch((err) => {
          return "f";
        });
    },
    async checkStock(lpo) {
      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);

      return fetchData(CHECK_STOCK, form)
        .then((res) => {
          return parseFloat(res.stock);
        })
    },

    checkKppTreeAmount(lpo) {
      const form = new FormData();
      form.append("lpo_id", lpo.lpo_id);

      return fetchData(CHECK_KPP_TREE_AMOUNT, form)
        .then((res) => {
          return res?.[0].czl_check_kpp_tree_amount;
        })
        .catch((err) => {
          console.log(err);
          return "f";
        });
    },
    async getMzl(lpo) {
			const form = new FormData();
			form.append('lpo_id', lpo.lpo_id);
			const response =  await fetch( GET_MZL, { method: 'POST',
        body: form
      });
      const res = await response.json();
      return res?.[0]?.id
		},

    
		async getManualMzl(lpo) {
			const form = new FormData();
			form.append('lpo_id', lpo.lpo_id);

			const response = await fetch( GET_MANUAL_MZL, { method: 'POST',
        body: form
      });
      const res = await response.json();
			return res?.[0]?.mzl_id;
		},
    async formActPrecheck(needExtra = true) {
      this.needExtra = needExtra;

      const lpoList = await this.getLpoList();

      this.incorrectDateLpoList = [];

      for (const lpo of lpoList) {
        const lastDate = new Date(lpo.inspection_date);
        lastDate.setDate(lastDate.getDate() + 30);

        if (new Date() > lastDate) {
          this.incorrectDateLpoList.push(lpo);
        }
      }

      if (this.incorrectDateLpoList.length) {
        this.confirmIsOpen = true;
      } else {
        this.formAct(needExtra);
      }
    },

    async formAct(needExtra = true) {
      this.confirmIsOpen = false;
      this.isForming = true;

      const lpoList = await this.getLpoList();
      const taxList = await this.getTax(lpoList);

      for (const lpo of lpoList) {
        // lpo['mainDamageList'] = await this.getMainDamageList(lpo);
        lpo["freqPestList"] = await this.getFreqPest(lpo);
        lpo["freqDiseaseList"] = await this.getFreqDisease(lpo);
        lpo["checkSPlot"] = await this.checkSPlot(lpo);
        lpo["modelTrees"] = await this.getModelTrees(lpo);
        lpo["vbPct"] = await this.getVbPct(lpo);
        lpo["checkProfMzlFitsSks"] = await this.checkProfMzlFitsSks(lpo);
        lpo["checkKppTreeAmount"] = await this.checkKppTreeAmount(lpo);
        lpo["checkIsLayerCorrect"] = await this.checkIsLayerCorrect(lpo.lpo_id);
        lpo["checkStock"] = await this.checkStock(lpo);
        lpo["mzl"] = await this.getMzl(lpo);
        lpo["m_mzl"] = await this.getManualMzl(lpo);
      }
      const requiredIncorrect2 = this._checkRequired2(taxList, lpoList);

      let dataIncorrect = false;

      for (const type in requiredIncorrect2) {
        if (!requiredIncorrect2[type].length) {
          continue;
        }

        dataIncorrect = true;
        let requiredIncorrectText =
          `${type}: ` + requiredIncorrect2[type].join(", ");
        this.$toast.add({
          severity: "warn",
          detail: requiredIncorrectText,
          life: 10000,
        });
      }

      if (dataIncorrect) {
        this.isForming = false;
        return;
      }

      const form = new FormData();
      form.append("lpo_id", this.currentLpo.lpo_id);
      form.append("lease_id", this.currentLpo.lease_id);

      fetch(FORM_ACT, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          const a = document.createElement("a");

          a.setAttribute("href", res.file);
          a.setAttribute("download", res.name);

          document.body.appendChild(a);
          a.click();
          a.remove();
        })
        .then((res) => {
          if (needExtra) {
            return fetch(process.env.VUE_APP_ROOT_API + "load_file/zip.php", {
              credentials: "include",
              method: "post",
              body: form,
            })
              .then((res) => res.blob())
              .then((res) => {
                let file_name = "Присоединенные_файлы";
                file_name += "_" + this.currentLpo.forestry;
                file_name += "_" + this.currentLpo.localforestry;
                file_name += "_" + (this.currentLpo.subforestry ?? "-");
                file_name += "_" + this.currentLpo.area;
                file_name += ".zip";

                const a = document.createElement("a");

                const url = window.URL.createObjectURL(res);

                a.setAttribute("href", url);
                a.setAttribute("download", file_name);

                document.body.appendChild(a);
                a.click();
                a.remove();
              });
          }
        })
        .catch((err) => {
          this.$toast.add({
            severity: "warn",
            detail: "При формировании акта произошла ошибка",
            life: 10000,
          });
          throw err;
        })
        .finally(() => {
          this.isForming = false;
        });
    },

    _checkRequired2(taxList, lpoList) {
      const incorrects = {};

      const labelTax = "Таксационное описание";
      incorrects[labelTax] = this._checkTax(taxList);

      for (let i = 0; i < lpoList.length; ++i) {
        const lpo = lpoList[i];

        const labelSection =
          "Выдел " +
          lpo.section +
          (lpo.section_lp ? "(" + lpo.section_lp + ")" : "");

        incorrects[labelSection] = this._checkLpo(lpo, i, taxList);
      }

      return incorrects;
    },

    _checkTax(taxList) {
      const incorrects = [];

      for (const tax of taxList) {
        if (!tax[0].forest_inventory_year) {
          incorrects.push("Год лесоустройства (ТО)");
        }
        if (!tax[0].forest_purpose_id) {
          incorrects.push("Целевое назначение лесов (ТО)");
        }
        if (!tax[0].s) {
          incorrects.push("Площадь лесотаксационного выдела (ТО)");
        }
        if (!tax[0].bonitet_id) {
          incorrects.push("Бонитет (ТО)");
        }
        if (!tax[0].forest_type) {
          incorrects.push("Тип леса (ТО)");
        }

        // if (!tax[0].tlu_id) {
        // 	incorrects.push('ТЛУ (ТО)');
        // }

        if (!tax[0].layer_id) {
          incorrects.push("Ярусы (ТО)");
        }
        if (!tax[0].species_id && !tax[0].non_forest_land_id) {
          incorrects.push("Породы яруса (ТО)");
        }
      }
      return incorrects;
    },

    _checkLpo(lpo, lpoIndex, taxList) {
      const incorrects = [];

      if (!lpo.inspection_date) {
        incorrects.push("Дата проведения обследования");
      }

      if (
        lpo.section_lp &&
        (lpo.s_lp === null || lpo.s_lp === "") &&
        (lpo.s_lp_manual === null || lpo.s_lp_manual === "")
      ) {
        incorrects.push("Площадь лесопатологического выдела отсутствует");
      }

      if (lpo.section_lp) {
        const s_lp =
          lpo.s_lp_manual !== null && lpo.s_lp_manual !== ""
            ? +lpo.s_lp_manual
            : +lpo.s_lp;
        if (s_lp > +taxList[lpoIndex][0].s) {
          incorrects.push(
            "Площадь лесопатологического выдела больше площади лесотаксационного выдела"
          );
        }
      }

      if (['1','2','3','4','5'].includes(lpo.inspection_type_id)) {
        // if (!lpo.mainDamageList.length) {
        // 	incorrects.push('Основная причина повреждения древесины');
        // }
        if (!lpo.critical_density) {
          incorrects.push("Критическая полнота");
        }
        if (lpo.mzl == "-1" && !lpo.m_mzl) {
          incorrects.push("Не выбрано значение в поле СОМ (ручной ввод)");
        }
        if (lpo.mzl != '-1') {
          //console.log(mzl)
          if (!lpo.mzl_period_to && lpo.mzl != '-3') {
            incorrects.push("Рекомендуемый срок проведения мероприятий");
          }
        } else if (lpo.m_mzl) {
          if (!lpo.mzl_period_to && lpo.m_mzl != '-3') {
            incorrects.push("Рекомендуемый срок проведения мероприятий");
          }
        }

        if (!this._isMzlPeriodToCorrect(lpo)) {
          incorrects.push("Дата крайних сроков мероприятия превышает 2 года");
        }

        /* Очаг */
        if (
          (lpo.freqDiseaseList.length || lpo.freqPestList.length) &&
          (!lpo.pest_core_number ||
            !lpo.pest_core_type_id ||
            !lpo.pest_core_phase_id)
        ) {
          incorrects.push("Очаг");
        }
      }
      if (['1','2','3','4','5','7'].includes(lpo.inspection_type_id)) {
        if (!lpo.decline_year_from) {
          incorrects.push("Время ослабления, повреждения насаждения");
        }
        if (!lpo.age_group) {
          incorrects.push("Группа возраста");
        }
        if (lpo.tax_accordance !== "t") {
          if (
            !lpo.disparity_reason ||
            !lpo.bonitet_id_new ||
            !lpo.forest_type_new
          ) {
            incorrects.push(
              "При несоответствии ТО необходимо заполнить поля причины несоответствия, бонитета, и типа леса"
            );
          }
        }
      }

      if (
        lpo.inspection_type_id === "1" ||
        lpo.inspection_type_id === "2" ||
        lpo.inspection_type_id === "3" ||
        lpo.inspection_type_id === "4"
      ) {
        /* Перечет */
        if (!lpo.modelTrees.length || lpo.modelTrees[0].is_draft === "t") {
          incorrects.push("Модельные деревья");
        }
      }

      if (lpo.inspection_type_id === "5") {
        if (+lpo.vbPct < 50) {
          incorrects.push("Бурелом ветровал > 50%");
        }
      }

      if (lpo.inspection_type_id === "1" && lpo.checkSPlot !== "t") {
        incorrects.push("Площадь выделенных лент недостаточна");
      }
      if (!['10', '9'].includes(lpo.inspection_type_id) && lpo.checkStock === 0) {
        incorrects.push(
          "Нет данных о запасе насаждения"
        );
      }
      if (!['10', '9'].includes(lpo.inspection_type_id) && lpo.checkProfMzlFitsSks !== "t" && lpo.checkStock > 0) {
        incorrects.push(
          "Назначение профилактических мероприятий возможно только при СКС насаждения 2,51 и более"
        );
      }

      if (
        lpo.checkIsLayerCorrect &&
        lpo.checkIsLayerCorrect?.is_correct !== "t"
      ) {
        incorrects.push(
          "Условия для выделения второго яруса не выполнены (полнота менее 0,3)!"
        );
      }

      if (lpo.inspection_type_id === "4" && lpo.checkKppTreeAmount !== "t") {
        incorrects.push("Среднее количество деревьев на 1й кпп менее 15");
      }

      return incorrects;
    },

    _isMzlPeriodToCorrect(lpo) {
      if (!lpo.mzl_period_to) {
        return true;
      }

      const lpo_year = new Date(lpo.inspection_date).getFullYear();
      const lpo_month = new Date(lpo.inspection_date).getMonth();
      const lpo_day = new Date(lpo.inspection_date).getDate();

      const mzl_year = new Date(lpo.mzl_period_to).getFullYear();
      const mzl_month = new Date(lpo.mzl_period_to).getMonth();
      const mzl_day = new Date(lpo.mzl_period_to).getDate();

      if (+mzl_year - +lpo_year > 2) {
        return false;
      } else if (+mzl_year - +lpo_year < 2) {
        return true;
      }

      if (+mzl_month > +lpo_month) {
        return false;
      } else if (+mzl_month < +lpo_month) {
        return true;
      }

      if (+mzl_day > +lpo_day) {
        return false;
      } else if (+mzl_day < +lpo_day) {
        return true;
      } else {
        return true;
      }

      return false;
    },

    ...mapActions("selectedLpo/recount", [
      "checkIsLayerCorrect",
      // 'checkSPlot'
    ]),
  },
};
</script>

<style scoped>
.confirm__title {
  font-size: 1.1rem;
  font-weight: bold;
}

.confirm__content {
  display: flex;
  align-items: center;
  gap: 1.2rem;
}

.confirm__proposition {
  margin-bottom: 1rem;
}

.confirm__section-item {
  display: list-item;
  list-style-position: inside;
}
</style>

<style scoped>
.form-act-block__btn::v-deep .p-button {
  font-size: 0.875rem !important;
  padding: 6.125px 12.25px;
}

.form-act-block {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.form-act-block__btn {
  width: 100%;
}

.p-progress-spinner {
  height: 30px;
  width: 30px;
}
</style>
